export function normalizeBillPaymentJobSettleCheck(data) {
  if (!data) {
    return {
      applyStatus: 'NORMAL',
      applyReason: '',
      needApprovalJobs: []
    }
  }

  if (typeof data === 'string') {
    if (data === 'NEED_APPROVAL' || data === 'NORMAL') {
      return {
        applyStatus: data,
        applyReason: '',
        needApprovalJobs: []
      }
    }
    return {
      applyStatus: 'NOT_SETTLE',
      applyReason: data,
      needApprovalJobs: []
    }
  }

  return {
    applyStatus: data.applyStatus || 'NORMAL',
    applyReason: data.applyReason || '',
    needApprovalJobs: data.needApprovalJobs || []
  }
}
